/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';

import {
  Components, Breakpoints, ThemeProps as Prop, GlobalLayoutValues,
  FontFamily,
  FontSize,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.UI_SECTION;

export const StyledUiSection = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ $isTransparent, $colorProfile }) => (($isTransparent) ? 'transparent' : themeUtil(Prop.BACKGROUND, CPNT, $colorProfile))};
  transition: 1s background-color linear;
  ${({ $hasDorLiftsTrailsAsChild }) => $hasDorLiftsTrailsAsChild && 'overflow-y: clip;'};

  ${({ scrollOffset }) => ((scrollOffset) ? `
    scroll-behavior: smooth;
    scroll-margin-top: ${scrollOffset}px;
  ` : '')}


  ${({ $backgroundImage, $backgroundCrop }) => $backgroundImage && css`
    background-image: url('${$backgroundImage}');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: ${`${$backgroundCrop}%` || 'center'} center;
  `}
`;

export const OuterWrapper = styled.div`
  width: 100%;
`;

const computePadding = ({
  top,
  bottom,
  $hasUiFooterAsChild,
  $hasUiHeaderAsChild,
  $hasNoPaddingGrid,
  $oneComponent,
  $isWrapperless,
}) => {
  let topPx = 50;
  let bottomPx = 50;

  if (top === null) {
    if ($hasUiHeaderAsChild || $hasNoPaddingGrid) topPx = 0;
  } else {
    topPx = top;
  }

  if (bottom === null) {
    if ($hasUiFooterAsChild || $hasNoPaddingGrid) bottomPx = 0;
  } else {
    bottomPx = bottom;
  }

  // remove padding entirely for single header/footer component
  if (
    top === null
    && bottom === null
    && (($hasUiFooterAsChild || $hasUiHeaderAsChild) && $oneComponent)
  ) {
    topPx = 0;
    bottomPx = 0;
  }

  // wrapperless override
  if ($isWrapperless) {
    topPx = 0;
    bottomPx = 0;
  }

  return {
    topPx,
    bottomPx,
  };
};

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({
    $hasUiFooterAsChild,
    $hasUiHeaderAsChild,
    $hasNoPaddingGrid,
    $oneComponent,
    $isWrapperless,
    $topPadding,
    $bottomPadding,
    $topPaddingMobile,
    $bottomPaddingMobile,
    $sidePadding,
  }) => {
    const desktop = computePadding({
      $hasUiFooterAsChild,
      $hasUiHeaderAsChild,
      $hasNoPaddingGrid,
      $oneComponent,
      $isWrapperless,
      top: $topPadding,
      bottom: $bottomPadding,
    });

    const mobile = computePadding({
      $hasUiFooterAsChild,
      $hasUiHeaderAsChild,
      $hasNoPaddingGrid,
      $oneComponent,
      $isWrapperless,
      top: $topPaddingMobile,
      bottom: $bottomPaddingMobile,
    });

    return `
      margin: ${desktop.topPx}px ${$sidePadding}% ${desktop.bottomPx}px;
      margin: ${desktop.topPx}px round(nearest, ${$sidePadding}%, 1px) ${desktop.bottomPx}px;

      ${Breakpoints.mobile(css`
        margin: ${mobile.topPx}px ${$sidePadding}% ${mobile.bottomPx}px;
        margin: ${mobile.topPx}px round(nearest, ${$sidePadding}%, 1px) ${mobile.bottomPx}px;
      `)}
    `;
  }}

  .temp-section-header {
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG10, undefined, undefined)};
    text-align: center;
  }

  ${Breakpoints.desktopOnly(css`
    .trapezoid-overlay {
      transform: skewX(-20deg);
      pointer-events: none;
      position: absolute;
      border: 1px black solid;
      width: 100%;
      height: 100%;
      z-index: 10;
    }

    .trapezoid-overlay + .section-inner .ui-column, .trapezoid-overlay + .section-inner .ui-column > ui-image {
      padding: 0;

      .ui-image {
        padding: 0;

        img {
          margin: 0;
        }
      }

      .ui-html {
        padding-left: 100px;
      }
    }
  `)}
`;

export const MaxWidthWrapper = styled.div`
  display: flex;
  width: 100%;
  ${({ $isIgnoreMaxWidth }) => (!$isIgnoreMaxWidth) && `max-width: ${GlobalLayoutValues.DESKTOP.WRAPPER_MAX}px;`};
`;

export const ComponentWrapper = styled.div`
  width: 100%;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;

  .loader-404 {
    height: auto;
    width: auto;
  }
`;
